import { useEffect, useState } from 'react';
import { getCapabilities } from '../lib/capabilities';
import { t } from '../locales';

/**
 * Gates the entire storefront (events list, event detail, checkout, my
 * tickets, organiser dashboard — everything under /i/:instanceSlug) behind
 * the tenant's ticketing_enabled capability. Without this, a tenant whose
 * license doesn't include ticketing still had a fully live-looking storefront
 * that only failed once a visitor reached checkout.
 */
export const TicketingEnabledGuard = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [ticketingEnabled, setTicketingEnabled] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const check = async () => {
            const capabilities = await getCapabilities();
            if (!cancelled) {
                setTicketingEnabled(capabilities.ticketing_enabled);
                setIsLoading(false);
            }
        };

        check();
        return () => { cancelled = true; };
    }, []);

    if (isLoading) {
        return null;
    }

    if (!ticketingEnabled) {
        return (
            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                <h2>{t('ticketingEnabledGuard.title')}</h2>
                <p>{t('ticketingEnabledGuard.description')}</p>
            </div>
        );
    }

    return children;
};

export default TicketingEnabledGuard;
